import React from "react";
import { FaGithub } from "react-icons/fa";
import { Link } from "react-router-dom";
import AOS from "aos";

const EachProject = ({ each }) => {
  const {
    id,
    title,
    tags,
    description,
    liveSite,
    clientRepo,
    serverRepo,
    images,
  } = each;

  return (
    <div
      data-aos="fade-up"
      data-aos-duration="1500"
      className="card shadow-xl bg-gradient-to-b from-blue-600 to-blue-800"
    >
      <figure className="">
        <img src={images[0]} className="max-h-[202px]" alt="Shoes" />
      </figure>
      <div className="card-body">
        <h2 className="card-title">
          {title}
          <div className="badge badge-secondary">NEW</div>
        </h2>
        <p>{description}</p>
        <div className="card-actions justify-end mt-6">
          {tags.map((tag, index) => (
            <div key={index} className="badge badge-outline">
              {tag}
            </div>
          ))}
        </div>
      </div>
      <div className="p-4 flex justify-center gap-3">
        <a
          href={liveSite}
          rel="noreferrer"
          className="btn btn-primary"
          target="_blank"
        >
          Live-Site
        </a>
        {serverRepo === "" ? (
          <a
            href={clientRepo}
            rel="noreferrer"
            className="btn btn-accent"
            target="_blank"
          >
            Github<FaGithub className="ml-1"></FaGithub>
          </a>
        ) : (
          <>
            <a
              href={clientRepo}
              rel="noreferrer"
              className="btn btn-accent"
              target="_blank"
            >
              Client<FaGithub className="ml-1"></FaGithub>
            </a>
            <a
              href={serverRepo}
              rel="noreferrer"
              className="btn btn-success"
              target="_blank"
            >
              Server<FaGithub className="ml-1"></FaGithub>
            </a>
          </>
        )}
      </div>
      <div className="flex justify-center pb-4">
        <Link to={`/projects/${id}`} className="btn btn-secondary w-1/2">
          View Details
        </Link>
      </div>
    </div>
  );
};

export default EachProject;
